export default __webpack_public_path__ + "static/middle-8c32a7356c0391a88d53f81dfa9e6fae.png";